/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imagescoverbadge2Inputs */

const en_imagescoverbadge2 = /** @type {(inputs: Imagescoverbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover`)
};

const de_imagescoverbadge2 = /** @type {(inputs: Imagescoverbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild`)
};

/**
* | output |
* | --- |
* | "Cover" |
*
* @param {Imagescoverbadge2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imagescoverbadge2 = /** @type {((inputs?: Imagescoverbadge2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imagescoverbadge2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imagescoverbadge2(inputs)
	return de_imagescoverbadge2(inputs)
});
export { imagescoverbadge2 as "imagesCoverBadge" }